const env = process.env;

window.General = {};

window.General.Site = env.REACT_APP_SITE
